import * as React from "react";
const SvgFiRrDove = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dove_svg__a)">
      <path
        fill="#062147"
        d="m23.311 3.999-1.407-.603c-.23-1.371-.94-2.428-2.027-2.972a3.98 3.98 0 0 0-3.054-.22 3.95 3.95 0 0 0-2.299 1.975l-.968 1.782c-1.755-.63-3.24-1.602-4.338-2.32l-.563-.366a1.7 1.7 0 0 0-1.75-.064 1.76 1.76 0 0 0-.894 1.558q0 .116.003.23c-.35-.384-.664-.746-.936-1.06l-.356-.408a1.54 1.54 0 0 0-1.749-.418 1.53 1.53 0 0 0-.969 1.499c.114 2.835.81 9.302 4.615 13.553l-4.767.233a2 2 0 0 0-1.432.758c-.337.428-.48.977-.392 1.508.29 1.738 1.688 4.08 4.077 5.112.342.148.707.223 1.077.223.418 0 .842-.095 1.246-.29l4.004-2.127a2 2 0 0 1 1.593-.123c.83.285 1.7.54 3.227.54a6.76 6.76 0 0 0 6.75-6.75c0-1.642-.007-5.923-.01-8.592l1.321-.566a1.137 1.137 0 0 0 0-2.09zm-15.29-.751c1.062.695 2.718 1.778 4.571 2.488l-.656 1.208c-1.309-.203-2.542-.906-3.63-1.766-.115-.355-.247-.963-.285-1.93M15.251 20c-1.223 0-1.865-.188-2.577-.433a4.02 4.02 0 0 0-3.183.249l-3.964 2.108a.77.77 0 0 1-.63.016c-1.626-.703-2.689-2.345-2.928-3.545l7.053-.345c.354-.018.7-.271.863-.585a1 1 0 0 0-.289-1.267C5.473 13.128 4.378 7 4.09 3.85 5.875 5.875 8.815 8.878 12.466 9c.365.005.731-.19.912-.522l2.92-5.373a1.98 1.98 0 0 1 1.156-1.002 1.98 1.98 0 0 1 1.525.11c.874.438 1.005 1.562 1.005 2.192 0 0 .015 9.08.015 10.845A4.756 4.756 0 0 1 15.25 20z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dove_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDove;
